module.exports = __webpack_public_path__ + "static/51-0f2df59d00c512de2dc1e8e62e78873d.png";